// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xS0T","buttons":"Footer_buttons__30sQN"};